import React, { useState } from 'react';
import Sidebar, { SIDEBAR_WIDTH } from './Sidebar';
import ContentTopBar from './ContentTopBar';
import AIDrawer from '../AIDrawer';
import { BG } from '../../lib/tokens';
import { useEventMode } from '../../lib/useEventMode';
import HomeScreen from '../../screens/HomeScreen';
import ScheduleScreen from '../../screens/ScheduleScreen';
import ParkingLotScreen from '../../screens/ParkingLotScreen';
import AttendeesScreen from '../../screens/AttendeesScreen';
import LogisticsScreen from '../../screens/LogisticsScreen';
import CommitmentsScreen from '../../screens/CommitmentsScreen';
import ResourcesScreen from '../../screens/ResourcesScreen';
import UploadsScreen from '../../screens/UploadsScreen';
import PostEventScreen from '../../screens/PostEventScreen';
import AdminScreen from '../../screens/AdminScreen';
import { useSchedule } from '../../lib/useSchedule';

export default function DesktopShell() {
  const [screen, setScreen] = useState('home');
  const [aiOpen, setAiOpen] = useState(false);
  const [activeDay, setActiveDay] = useState(0);
  const { day: detectedDay } = useSchedule();
  const [isPostEvent, setIsPostEvent] = useEventMode(false);

  // Keep the schedule on the right day by default once the live data loads.
  React.useEffect(() => setActiveDay(detectedDay), [detectedDay]);

  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100vw',
        background: BG,
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Sidebar activeScreen={screen} onNavigate={setScreen} isPostEvent={isPostEvent} />

      <main
        style={{
          marginLeft: SIDEBAR_WIDTH,
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          minWidth: 0,
        }}
      >
        <ContentTopBar screen={screen} onAITap={() => setAiOpen(true)} />
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            padding: '24px 28px 32px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {renderScreen(screen, {
            isPostEvent,
            setIsPostEvent,
            activeDay,
            setActiveDay,
          })}
        </div>
      </main>

      <AIDrawer open={aiOpen} onClose={() => setAiOpen(false)} />
    </div>
  );
}

function renderScreen(screen, props) {
  switch (screen) {
    case 'home':
      return <HomeScreen isPostEvent={props.isPostEvent} />;
    case 'schedule':
      return <ScheduleScreen activeDay={props.activeDay} setActiveDay={props.setActiveDay} />;
    case 'parking-lot':
      return <ParkingLotScreen />;
    case 'attendees':
      return <AttendeesScreen />;
    case 'logistics':
      return <LogisticsScreen />;
    case 'commitments':
      return <CommitmentsScreen />;
    case 'resources':
      return <ResourcesScreen />;
    case 'uploads':
      return <UploadsScreen />;
    case 'post-event':
      return <PostEventScreen isPostEvent={props.isPostEvent} />;
    case 'admin':
      return <AdminScreen isPostEvent={props.isPostEvent} setIsPostEvent={props.setIsPostEvent} />;
    default:
      return null;
  }
}
